<template>
</template>

<script>
import InlineEditor from '../app/InlineEditor.vue';
import Modal from '../modal/Modal.vue';
import UploadModal from '../modal/UploadModal.vue';
import SocialIcons from '../navigation/SocialIcons.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components:{
        InlineEditor,
        Modal,
        UploadModal,
        SocialIcons
    },
    props:{
      content: {
        type: Object
      },
      homeimage: {
          type: String
      },
      websiteid: {
          type: String
      },
      readonly: {
        type: Boolean
      }
    },
    data: function() {
        return{
            thisobject: this.content,
            imageModal: false,
            file: '',
            images: [],
            imageroot: process.env.VUE_APP_ROOT_API + '/'
        }
    },
    methods: {
        setblockimage(image){
            this.homeimage = this.imageroot+image.split("uploads/").pop()
        },
        getimages(){

            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/media/'+this.websiteid, requestOptions)
            .then(response => {
                this.images = response.data.response
            })
        },
        changeSiteSetting(thedbentry, thecontent){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
                websiteid: this.websiteid,
                dbentry: thedbentry,
                content: thecontent
            }

            console.log(data)

            axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
            .then(response => {
                console.log(response)
                if(thedbentry == 'blockalign'){
                    this.blockalign = thecontent
                } 
                if (thedbentry == 'blockheight') {
                    this.blockheight = thecontent
                }
                if (thedbentry == 'blockfontsize') {
                    this.blockfontsize = thecontent
                }
                if (thedbentry == 'mainblockimage') {
                    this.imageModal = false
                }
            })
        }
    }
}
</script>